import React from 'react';

import clsxm from '@/lib/clsxm';

import Icon from '../Icon';

export interface IProps
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  icon: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  iconClassName?: string;
  iconWidth?: number;
  iconHeight?: number;
  isLoading?: boolean;
  isGrayedOut?: boolean;
}

export default function IconButton({
  className = '',
  icon,
  iconWidth = 20,
  iconHeight = 20,
  iconClassName,
  onClick,
  isLoading,
  disabled,
  isGrayedOut,
}: IProps) {
  return (
    <button
      className={clsxm('p-2', className)}
      onClick={disabled || isLoading ? undefined : onClick}
    >
      <Icon
        name={icon}
        width={iconWidth}
        height={iconHeight}
        className={clsxm(iconClassName)}
        isGrayedOut={isGrayedOut}
      />
    </button>
  );
}
